import { Container, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Stack } from "@mui/system";
import queryString from "query-string";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { init } from "../../redux/actions/dataAnalysis";
import Footer from "../common/Footer";
import Header from "../common/Header";
import "../css/DataAnalysis.css";

export default function DataAnalysis() {
  <rows style={{ border: 3, bordercolor: "black" }} />;

  const dispatch = useDispatch();
  const grade = useSelector(state => state.dataAnalysis.grade);
  const classNumber = useSelector(state => state.dataAnalysis.class);
  const number = useSelector(state => state.dataAnalysis.number);
  const name = useSelector(state => state.dataAnalysis.name);
  const listName = useSelector(state => state.dataAnalysis.listName);
  const evaluationTerm = useSelector(state => state.dataAnalysis.evaluationTerms);
  const gradeList = useSelector(state => state.dataAnalysis.gradeList);
  const evaluationItems = useSelector(state => state.dataAnalysis.evaluationItems);
  const selfEvaluations = useSelector(state => state.dataAnalysis.selfEvaluations);
  const otherUserEvaluations = useSelector(state => state.dataAnalysis.otherUserEvaluations);
  const priorityTargets = useSelector(state => state.dataAnalysis.priorityTargets);

  useEffect(
    () => {
      const currentUrl = window.location.href;

      const parsedUrl = queryString.parseUrl(currentUrl);

      const { studentId, listId } = parsedUrl.query;
      const params = { studentId: studentId, listId: listId };

      dispatch(init(params));
    },
    [dispatch]
  );

  const convertGrading = grading => {
    switch (grading) {
      case "01":
        return "S";
      case "02":
        return "A";
      case "03":
        return "B";
      case "04":
        return "C";
      case "05":
        return "D";
      case "06":
        return "E";
      default:
        return "";
    }
  };
  return (
    <Box>
      <Header />
      <Container>
        <Box
          sx={{
            marginTop: 4,
            marginLeft: 8,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            データ分析
          </Typography>
        </Box>

        <Box
          sx={{
            marginTop: 4,
            marginLeft: 16,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            対象生徒
          </Typography>
        </Box>

        <Box
          sx={{
            marginTop: 1,
            marginLeft: 16,
            marginRight: 76,
            bgcolor: "#fff9c4",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Stack direction="row" spacing={5}>
            <p>
              {name}
            </p>
            <p>
              {grade}年
            </p>
            <p>
              {classNumber}組
            </p>
            <p>
              {number}番
            </p>
            <br />
          </Stack>
        </Box>

        <Box
          sx={{
            marginTop: 1,
            marginLeft: 16,
            marginRight: 76,
            bgcolor: "#fff9c4",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Stack direction="row" spacing={15}>
            <Typography>評価内容</Typography>
            <Typography>
              {listName}
            </Typography>
          </Stack>
        </Box>
        <div className="table-div">
          <table>
            <tbody>
              <tr>
                <th className="text-left" rowSpan="4">
                  評価項目
                </th>
              </tr>
              <tr>
                {gradeList.map((grade, index) =>
                  <th key={index} colSpan={evaluationTerm.length * 2}>
                    {grade}年
                  </th>
                )}
              </tr>
              <tr>
                {gradeList.map(grade =>
                  evaluationTerm.map(term =>
                    <th key={`${grade}-${term.termId}`} colSpan="2">
                      {term.termName}
                    </th>
                  )
                )}
              </tr>
              <tr>
                {gradeList.map(grade =>
                  <React.Fragment key={grade}>
                    {evaluationTerm.map(term =>
                      <React.Fragment key={term.itemId}>
                        <th>自己評価</th>
                        <th>他者評価</th>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </tr>
              <tr>
                <td className="text-left">重点目標1</td>
                {gradeList.map((grade, gradeIndex) =>
                  evaluationTerm.map((term, termIndex) =>
                    <React.Fragment key={`${grade}-${termIndex}`}>
                      <td>
                        {(() => {
                          let count = 0;
                          return priorityTargets
                            .filter(evaluation => evaluation.grade === grade && evaluation.termId === term.termId)
                            .map(filteredItem => {
                              count++;
                              if (count === 1) {
                                return (
                                  <div key={filteredItem.itemId}>
                                    {evaluationItems.map((item, index) => {
                                      if (item.itemId === filteredItem.itemId) {
                                        return (
                                          <div key={item.itemId}>
                                            {index + 1}
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                );
                              }
                              return null;
                            });
                        })()}
                      </td>
                      <td />
                    </React.Fragment>
                  )
                )}
              </tr>
              <tr>
                <td className="text-left">重点目標2</td>
                {gradeList.map((grade, gradeIndex) =>
                  evaluationTerm.map((term, termIndex) =>
                    <React.Fragment key={`${grade}-${termIndex}`}>
                      <td>
                        {(() => {
                          let count = 0;
                          return priorityTargets
                            .filter(evaluation => evaluation.grade === grade && evaluation.termId === term.termId)
                            .map(filteredItem => {
                              count++;
                              if (count === 2) {
                                return (
                                  <div key={filteredItem.itemId}>
                                    {evaluationItems.map((item, index) => {
                                      if (item.itemId === filteredItem.itemId) {
                                        return (
                                          <div key={item.itemId}>
                                            {index + 1}
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                );
                              }
                              return null;
                            });
                        })()}
                      </td>
                      <td />
                    </React.Fragment>
                  )
                )}
              </tr>
              <tr>
                <td className="text-left">重点目標3</td>
                {gradeList.map((grade, gradeIndex) =>
                  evaluationTerm.map((term, termIndex) =>
                    <React.Fragment key={`${grade}-${termIndex}`}>
                      <td>
                        {(() => {
                          let count = 0;
                          return priorityTargets
                            .filter(evaluation => evaluation.grade === grade && evaluation.termId === term.termId)
                            .map(filteredItem => {
                              count++;
                              if (count === 3) {
                                return (
                                  <div key={filteredItem.itemId}>
                                    {evaluationItems.map((item, index) => {
                                      if (item.itemId === filteredItem.itemId) {
                                        return (
                                          <div key={item.itemId}>
                                            {index + 1}
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                );
                              }
                              return null;
                            });
                        })()}
                      </td>
                      <td />
                    </React.Fragment>
                  )
                )}
              </tr>
              <tr style={{ backgroundColor: "gray" }}>
                <td />
                {gradeList.map((grade, gradeIndex) =>
                  evaluationTerm.map((term, termIndex) =>
                    <React.Fragment key={termIndex}>
                      <td />
                      <td />
                    </React.Fragment>
                  )
                )}
              </tr>
              {evaluationItems.map((item, itemIndex) =>
                <React.Fragment key={itemIndex}>
                  <tr>
                    <td className="text-left">
                      {itemIndex + 1}.{item.itemName}
                    </td>
                    {gradeList.map((grade, gradeIndex) =>
                      evaluationTerm.map((term, termIndex) =>
                        <React.Fragment key={termIndex}>
                          <td>
                            {selfEvaluations
                              .filter(
                                evaluation =>
                                  evaluation.grade === grade &&
                                  evaluation.itemId === item.itemId &&
                                  evaluation.termId === term.termId
                              )
                              .map((filteredItem, filteredIndex) =>
                                <div key={filteredIndex}>
                                  {convertGrading(filteredItem.grading)}
                                </div>
                              )}
                          </td>
                          <td>
                            {otherUserEvaluations
                              .filter(
                                evaluation =>
                                  evaluation.grade === grade &&
                                  evaluation.itemId === item.itemId &&
                                  evaluation.termId === term.termId
                              )
                              .map((filteredItem, filteredIndex) =>
                                <div key={filteredIndex}>
                                  {convertGrading(filteredItem.grading)}
                                </div>
                              )}
                          </td>
                        </React.Fragment>
                      )
                    )}
                  </tr>
                </React.Fragment>
              )}
            </tbody>
          </table>
        </div>
      </Container>
      <Box sx={{ alignItems: "right", justifyContent: "right", m: 3, mr: 12, display: "flex" }}>
        <Button
          variant="contained"
          size="medium"
          href="/EvaluationAnalysis"
          sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}
        >
          戻る
        </Button>
      </Box>
      <Footer />
    </Box>
  );
}
